import { Store } from 'libx';
import moment from 'moment';
import { extractQueryParams, serializeQueryParams } from './../utils';

export default class BaseQueryParamsStore extends Store {

  constructor() {
    super(...arguments);

    if (this.constructor === BaseQueryParamsStore)
      throw new Error('BaseQueryParamsStore can not be instantiated on its own');

    this.extractQueryParams();
    window.addEventListener('popstate', this.extractQueryParams.bind(this));
  }

  extractQueryParams() {
    return extractQueryParams();
  }

  extractRawParam(queryParams, name, defaultValue) {
    this.queryParams[name] = queryParams[name] || defaultValue;
  }

  extractNumberParam(queryParams, name, min = -Infinity, max = Infinity) {
    const value = queryParams[name];

    if (!value) return;

    const number = Number(value);
    if (isNaN(number)) {
      this.handleExtractionError(`Invalid ${name} query parameter. Value must be a number, got: ${value}`);
      return;
    }

    if (number >= min && number <= max) {
      this.queryParams[name] = number;
    } else {
      this.handleExtractionError(`Invalid ${name} query parameter. Value must be in range: ${min} - ${max}`);
    }
  }

  extractDictionaryParam(queryParams, name, dictionary) {
    const value = queryParams[name];
    const supportedValues = Object.values(dictionary);

    if (!value) return;

    if (supportedValues.includes(value)) {
      this.queryParams[name] = value;
    } else {
      this.handleExtractionError(`Invalid ${name} query parameter. Supported values are: ${supportedValues.join(', ')}. Got: ${value}`);
    }
  }

  extractDateParam(queryParams, name, format, min, max) {
    const value = queryParams[name];

    if (!value) {
      this.queryParams[name] = null;
      return;
    }

    const date = moment(value, format, true);
    const isValid = date.isValid();
    const fitsMin = min ? date > min : true;
    const fitsMax = max ? date < max : true;

    if (isValid && fitsMin && fitsMax) {
      this.queryParams[name] = value;
    } else {
      const messages = [
        `Expected format: ${format}`,
        min ? `Minimal date: ${min.format(format)}` : '',
        max ? `Maximal date: ${max.format(format)}` : ''
      ].filter(m => !!m);
      this.handleExtractionError(`Invalid ${name} query parameter. ${messages.join(', ')}. Got: ${value}`)
    }
  }

  handleExtractionError(message) {
    console.warn(message);
  }

  updateUrl() {
    serializeQueryParams(this.queryParams, this.DEFAULT_QUERY_PARAMS);
  }

}




// WEBPACK FOOTER //
// ./src/shared/stores/BaseQueryParamsStore.js